<template>
    <Card :bordered="false" class="border-radius-0">
        <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
        <Tabs v-model:activeKey="tabKey" v-if="data.useForm.modelRef?.refPersonType?.key === '1'" class="mb-3">
            <TabPane key="UserSyndicate" :tab="$t('views.request.register.company')" :forceRender="true">
                <UserSyndicateForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    :isLoading="isLoading"
                    itemsKey="userCorporateCommittees"
                    canCreate="!viewOnly"
                    canDelete="!viewOnly"
                ></UserSyndicateForm>
            </TabPane>
            <TabPane key="Attachment" :tab="$t('views.request.attachment.title')" :forceRender="true">
                <AttachmentForm
                    :menuContext="menuContext"
                    :viewOnly="viewOnly"
                    :dataProp="data"
                    :isLoading="isLoading"
                    itemsKey="attachments"
                    canCreate="!viewOnly"
                    canDelete="!viewOnly"
                ></AttachmentForm>
            </TabPane>
        </Tabs>
        <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.statusCardFields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
    </Card>
</template>

<script>
import { Card, Form, Tabs } from "ant-design-vue";
import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
import { useRoute } from "vue-router";
import { state as stateApp } from "../../../../app.logic";
import { createFormTitle, initForm, isLoading, state } from "./user-request-register-approve.logic";

export default defineComponent({
    components: {
        Card,
        Form,
        Tabs,
        TabPane: Tabs.TabPane,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../components/input/template-builder/TemplateBuilder")),
        UserSyndicateForm: defineAsyncComponent(() => import("../../../account/register-fisherman/user-syndicate/UserSyndicateForm")),
        AttachmentForm: defineAsyncComponent(() => import("../../../account/register-fisherman/attachment/AttachmentForm"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: { default: false },
        routerPrefix: { default: "user-requests" },
        form: {},
        setAppPageHeader: { default: true },
        visibleChangeLog: { default: true },
        forceDefault: { default: false }
    },
    setup(props) {
        const route = useRoute();
        const id = props.form ? props.form.id : route.params?.id;
        const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [] });
        const refs = reactive({ form: null });
        initForm({ props, data, refs, route });
        const title = computed(() => createFormTitle({ data }));
        return {
            props,
            data,
            refs,
            state,
            title,
            isLoading
        };
    }
});
</script>
